import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import SelectAutocompleteMultiple from "components/SelectAutocompleteMultiple";
import {
  AgreementStatusResponse,
  ListResponseOfAgreementStatusResponse,
} from "services/KnowfullyAdminClient";
import persistanceStore from "stores/persistanceStore";
import { useStrictQuery } from "hooks/useStrictQuery";
import useGlobalContext from "hooks/globalData";
import { AgreementStatuses } from "types/common-types";

const SelectAgreementStatuses = () => {
  const { formatMessage: t } = useIntl();
  const [statuses, setStatuses] = useState<AgreementStatusResponse[]>([]);
  const [selectedStatuses, setSelectedStatuses] = useState<
    AgreementStatusResponse[]
  >([]);

  const agreementStatusIds = persistanceStore.useState(
    (s) => s.agreementFilterStatusIds
  );
  const hasInitialized = persistanceStore.useState(
    (s) => s.hasAgreementStatusInitialized
  );

  const { agreementService } = useGlobalContext();

  const fetchedStatuses = useStrictQuery<ListResponseOfAgreementStatusResponse>(
    ["agreementService.getStatuses"],
    () => agreementService.getStatuses()
  );

  useEffect(() => {
    if (fetchedStatuses?.data?.data) {
      const statuses = fetchedStatuses.data.data;

      setStatuses(statuses);

      let preselected: AgreementStatusResponse[] = [];

      if (agreementStatusIds && agreementStatusIds.length > 0) {
        preselected = agreementStatusIds
          .map((id) => statuses.find((s) => s.id === id))
          .filter((s): s is AgreementStatusResponse => s !== undefined);
      } else if (!hasInitialized) {
        preselected = statuses.filter(
          (s) =>
            s.name === AgreementStatuses.Draft ||
            s.name === AgreementStatuses.Active
        );

        persistanceStore.update((s) => {
          s.agreementFilterStatusIds = preselected.map((s) => s.id!);
          s.hasAgreementStatusInitialized = true;
        });
      }

      setSelectedStatuses(preselected);
    }
  }, [fetchedStatuses, agreementStatusIds, hasInitialized]);

  return (
    <SelectAutocompleteMultiple
      label={t({ id: "statusLabel" })}
      limitTags={2}
      options={statuses}
      getOptionLabel={(option) => option.name!}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={selectedStatuses}
      onChange={(event, newValue) => {
        setSelectedStatuses(newValue);
        persistanceStore.update((s) => {
          s.agreementFilterStatusIds = newValue.map((s) => s.id!);
        });
      }}
    />
  );
};

export default SelectAgreementStatuses;
